import React from 'react';
import { Modal } from "flowbite-react";
import ModalCloseButton from "./ModalCloseButton";

/**
 * BaseModal provides a consistent layout for all modals in the application.
 * It includes a custom close button and standardized padding/spacing.
 */
function BaseModal({
    show,
    onClose,
    title,
    children,
    footer,
    size = "2xl",
    position = "center",
}) {
    return (
        <Modal show={show} size={size} position={position} onClose={onClose}>
            <ModalCloseButton onClick={onClose} />
            {/* Custom Header with specific padding for close button */}
            <div className="flex items-start justify-between p-5 border-b border-gray-200 rounded-t">
                <h3 className="text-xl font-semibold text-gray-900">
                    {title}
                </h3>
            </div>
            <Modal.Body>
                <div className="space-y-6 m-4">
                    {children}
                </div>
            </Modal.Body>
            {footer && (
                <Modal.Footer className="border-t border-gray-200">
                    <div className="flex flex-wrap gap-4 w-full justify-center mb-10">
                        {footer}
                    </div>
                </Modal.Footer>
            )}
        </Modal>
    );
}

export default BaseModal;
